import React from 'react';
import { shape, number, string, arrayOf, bool, func, object } from 'prop-types';
import { LOGO_PROJECT_CARD } from '@fiverr-private/variations_display/src';
import Listings from '../Listings';
import ShortBrief from '../brief/ShortBrief';
import { IndustriesContextProvider } from '../shared/IndustriesContext';
import { PAGE } from './constants';
import useRoot from './hooks/useRoot';

const Root = ({
    logoMakerConfig = {},
    onNavigateToLogoServicesClick,
    rollouts,
}) => {
    const { page, briefData, briefId, setBriefData, handleShortBriefSubmit } =
        useRoot({ logoMakerConfig });

    return (
        <IndustriesContextProvider>
            {page === PAGE.BRIEF && (
                <ShortBrief
                    onSubmit={handleShortBriefSubmit}
                    briefData={briefData}
                    setBriefData={setBriefData}
                />
            )}
            {page === PAGE.LISTING && (
                <Listings
                    logoMakerConfig={logoMakerConfig.listings.projects}
                    onNavigateToLogoServicesClick={
                        onNavigateToLogoServicesClick
                    }
                    rollouts={rollouts}
                    briefData={briefData}
                    briefId={briefId}
                    setBriefData={setBriefData}
                />
            )}
        </IndustriesContextProvider>
    );
};

Root.propTypes = {
    logoMakerConfig: shape({
        listings: shape({
            shouldShow: bool,
            testGroup: number,
            projects: arrayOf(shape(LOGO_PROJECT_CARD)),
            hasNextPage: bool,
        }),
        searchQuery: string,
    }),
    onNavigateToLogoServicesClick: func,
    rollouts: object,
};

export default Root;
